import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatIconModule, MatSnackBarModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CustomSnackBarComponent } from './custom-snackbar.component';

@NgModule({
  entryComponents: [
    CustomSnackBarComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatSnackBarModule,
    MatButtonModule
  ],
  declarations: [
    CustomSnackBarComponent
  ],
  exports: [
    CustomSnackBarComponent
  ]
})
export class CustomSnackBarModule {}
